document.addEventListener("DOMContentLoaded", function () {
  const observer = new MutationObserver(function (mutations, obs) {
    const bubble = document.getElementById("cw-bubble-holder");
    const footerButtonChat = document.getElementById("footer-button-chat");

    if (bubble && footerButtonChat) {
      const chatLinks = document.querySelectorAll(".chat-link");

      chatLinks.forEach(function (link) {
        link.addEventListener("click", function (e) {
          e.preventDefault();
          bubble.click();
        });
      });

      footerButtonChat.addEventListener("click", function (e) {
        e.preventDefault();
        bubble.click();
      });

      obs.disconnect();
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
});

